/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_ErrorInputs */

const en_mk_price_error = /** @type {(inputs: Mk_Price_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plans could not be loaded. Try again or open the pricing page.`)
};

const id_mk_price_error = /** @type {(inputs: Mk_Price_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket belum bisa dimuat. Coba lagi atau buka halaman harga.`)
};

/**
* | output |
* | --- |
* | "Plans could not be loaded. Try again or open the pricing page." |
*
* @param {Mk_Price_ErrorInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_error = /** @type {((inputs?: Mk_Price_ErrorInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_ErrorInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_error(inputs)
	return en_mk_price_error(inputs)
});